/* tslint:disable */
/* eslint-disable */
/**
 * radia.cz
 * Seznam endpointu
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FrontWebRadioStreamPlaylistModel
 */
export interface FrontWebRadioStreamPlaylistModel {
    /**
     * Type
     * @type {string}
     * @memberof FrontWebRadioStreamPlaylistModel
     */
    type: string;
    /**
     * url
     * @type {string}
     * @memberof FrontWebRadioStreamPlaylistModel
     */
    url: string;
}

/**
 * Check if a given object implements the FrontWebRadioStreamPlaylistModel interface.
 */
export function instanceOfFrontWebRadioStreamPlaylistModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "url" in value;

    return isInstance;
}

export function FrontWebRadioStreamPlaylistModelFromJSON(json: any): FrontWebRadioStreamPlaylistModel {
    return FrontWebRadioStreamPlaylistModelFromJSONTyped(json, false);
}

export function FrontWebRadioStreamPlaylistModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FrontWebRadioStreamPlaylistModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'url': json['url'],
    };
}

export function FrontWebRadioStreamPlaylistModelToJSON(value?: FrontWebRadioStreamPlaylistModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'url': value.url,
    };
}

